export const getters = {
  tickets (state) {
    return state.tickets
  },
  ticket (state) {
    return state.ticket
  },  
  pagination(state){
    return state.pagination
  }
}
